export default "__VITE_ASSET__CMHvtjNA__"